import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { LANDING_PAGE_PATH } from "utils/constants/paths";

const LandingPage = Loadable(React.lazy(() => import("./View")));

export const LandingPageRoute: IRouteItem = {
  path: LANDING_PAGE_PATH,
  element: React.createElement(LandingPage),
  name: "Landing Page",
};
